// src/lib/prefetchRoutes.ts

// Kick off these dynamic imports once per session.
// They download the code-splits but DON’T block the UI
// (network happens in the background after first paint).

export function prefetchBottomNavRoutes() {
  /* 1️⃣  “Clubs”  — heaviest / longest */
  import(/* webpackPrefetch: true */ '../pages/FacilityBooking');
  import(/* webpackPrefetch: true */ '../components/facilities/FacilityManagement');

  /* 2️⃣  “Feed” */
  import(/* webpackPrefetch: true */ '../pages/Dashboard');

  /* 3️⃣  “Play” (quick-play flow) */
  import(/* webpackPrefetch: true */ '../pages/QuickPlayWrapper');
  import(/* webpackPrefetch: true */ '../pages/QuickPlayTransition');

  /* ─── “Players” (matchmaking) ─── */
  import(/* webpackPrefetch: true */ '../pages/MatchMaking');

  /* 4️⃣  “My Activities” */
  import(/* webpackPrefetch: true */ '../pages/Activities');

  /* 5️⃣  “Messages” */
  import(/* webpackPrefetch: true */ '../pages/Messages');

  /* ───────────── Extra sections users hit next ───────────── */

  /* “My Profile” */
  import(/* webpackPrefetch: true */ '../pages/Profile');

  /* “Players / Search” list + individual member card */
  import(/* webpackPrefetch: true */ '../pages/Search');
  import(/* webpackPrefetch: true */ '../pages/MemberProfile');

  /* Forums – landing + drill-downs */
  import(/* webpackPrefetch: true */ '../pages/Forums');
  import(/* webpackPrefetch: true */ '../pages/ForumCategory');
  import(/* webpackPrefetch: true */ '../pages/ForumTopic');
  import(/* webpackPrefetch: true */ '../pages/NewForumTopic');
  import(/* webpackPrefetch: true */ '../pages/ClubForumCategory');
}
